import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import { useSeo } from "@/hooks/useSeo";
import { siteInfo } from "@/mocks/site";
import AboutIntro from "./components/AboutIntro";
import AboutVoice from "./components/AboutVoice";

export default function AboutPage() {
  useSeo({
    title: "关于我们 | 爆料51匿名通道的定位与内容原则",
    description:
      "了解爆料51匿名通道的品牌介绍、网站定位、发展理念与内容原则。我们以隐私保护和保密机制为前提，让匿名投稿与安全爆料不必以牺牲个人安全为代价。",
    keywords: "爆料51关于我们,匿名通道,隐私保护,内容原则,保密机制",
    path: "/about",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://cwxxkj.cn/" },
          { "@type": "ListItem", position: 2, name: "关于我们", item: "https://cwxxkj.cn/about" },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "关于我们 | 爆料51匿名通道的定位与内容原则",
        url: "https://cwxxkj.cn/about",
        description: "爆料51匿名通道的品牌介绍、定位、发展理念与内容原则。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.fullName,
        url: "https://cwxxkj.cn/",
        email: siteInfo.email,
        foundingDate: siteInfo.foundedYear,
        description: siteInfo.shortDesc,
      },
    ],
  });

  return (
    <SiteLayout>
      <PageHero
        eyebrow="About Us"
        title="关于爆料51：让说真话这件事不再有代价"
        subtitle="我们不是媒体，也不是平台。我们只想把一条匿名通道维护好，让愿意说真话的人不必先担心自己的安全。"
        crumbs={[{ label: "首页", to: "/" }, { label: "关于我们" }]}
      />
      <AboutIntro />
      <AboutVoice />
    </SiteLayout>
  );
}